import PlatformPage from '../PlatformPage';

const ForShopify = () => (
  <PlatformPage
    slug="shopify"
    name="Shopify"
    title="Website Feedback Tool for Shopify Stores"
    description="Visual feedback on your live Shopify storefront. Native app, one click install, no theme code. Notes and bugs for your team, invisible to shoppers."
    h1="Website feedback tool built for Shopify stores."
    intro="Connect your store, switch on the Cayda app embed, and your team can click on any element of your live storefront to leave a note. Product pages, collections, the cart, your blog. Shoppers never see a thing."
    steps={[
      { title: 'Add your store in the Cayda dashboard', desc: 'Choose Shopify, enter your store domain and approve the install in Shopify. No theme files are touched.' },
      { title: 'Open Online Store → Themes → Customize', desc: 'In your Shopify admin, on the theme you want to review.' },
      { title: 'Open App embeds and toggle on Cayda Widget', desc: 'The puzzle piece icon in the theme editor sidebar.' },
      { title: 'Save', desc: 'The feedback layer is live on every storefront page for your team.' },
    ]}
    stepsNote="There is no token to paste: the app embed identifies your store by its myshopify domain. Prefer code? The same snippet can go into theme.liquid instead."
    loads={{
      title: 'Built for how Shopify themes load',
      paragraphs: [
        'Shopify storefronts do a full page load on navigation, so the Cayda script runs on every page automatically. Product pages, collection pages, the cart, blog posts, landing pages and custom templates all work out of the box, on Online Store 2.0 themes and older ones alike.',
        'Because Cayda lives in the theme editor as an app embed, it does not edit your theme code, so theme updates and section changes do not dislodge it. Checkout runs on Shopify’s own infrastructure and does not load theme scripts, so notes stop at the cart.',
      ],
    }}
    where={{
      title: 'Where your team leaves notes',
      paragraphs: [
        'Anywhere on the storefront: a product image that needs a retake, a price that is showing the wrong compare-at, a collection banner that is cropped on mobile, a menu item that goes nowhere. Click the element, type the note, and it is pinned there with a screenshot, the URL, the browser, OS and viewport, so whoever picks it up sees exactly what you saw.',
        'Notes carry a type (bug, design, content, question or feedback), a status, a priority and an assignee, and they show up in a Kanban or list view across all your stores. Agencies managing several Shopify clients keep each store as its own site with its own team.',
      ],
    }}
    extras={[
      {
        title: 'Invisible to your customers',
        paragraphs: [
          'The Cayda script activates only for authenticated team members and invited guests. For every shopper it renders nothing, sets no cookies, and adds no meaningful weight, so you can leave feedback on the live store rather than a duplicate theme, and your conversion rate never knows Cayda is there.',
        ],
      },
    ]}
    ctaTitle="Add feedback to your Shopify store."
    ctaSub="Connect the store, toggle the app embed, and start leaving notes in under two minutes."
  />
);

export default ForShopify;
